import React, { Component } from "react";

import "../../css/sticky-footer.css";

class StickyFooter extends Component {
	render() {
		return <div className="sticky sticky--footer">{this.props.children}</div>;
	}
}

export default StickyFooter;



// WEBPACK FOOTER //
// ./src/components/utils/StickyFooter.js